import {
  computePosition, arrow, offset, shift,
} from '@floating-ui/dom';
import domReady from '../helpers/dom-ready';

class ExhibitionViewOptions {
  static init() {
    return new ExhibitionViewOptions();
  }

  constructor() {
    const exhibitionHeader = document.querySelector('.exhibition-header');
    if (!exhibitionHeader) { return; }

    const openVideoPlayerButton = exhibitionHeader.querySelector('.open-video-player-button');
    const openVideoPlayerTooltip = exhibitionHeader.querySelector('#open-video-player-tooltip');

    const openAudioPlayerButton = exhibitionHeader.querySelector('.open-audio-player-button');
    const openAudioPlayerTooltip = exhibitionHeader.querySelector('#open-audio-player-tooltip');

    const openLanguageSwitcherButton = exhibitionHeader.querySelector('.language-switcher');
    const openLanguageSwitcherTooltip = exhibitionHeader.querySelector('#language-switcher-tooltip');

    this.addTooltip(openVideoPlayerButton, openVideoPlayerTooltip);
    this.addTooltip(openAudioPlayerButton, openAudioPlayerTooltip);
    this.addTooltip(openLanguageSwitcherButton, openLanguageSwitcherTooltip);
  }

  addTooltip(button, tooltip) {
    if (!tooltip) { return; }
    const tooltipArrow = tooltip.querySelector('.arrow');

    function update() {
      computePosition(
        button,
        tooltip,
        {
          placement: 'bottom',
          middleware: [
            offset(12),
            shift({ padding: 4 }),
            arrow({ element: tooltipArrow }),
          ],
        },
      ).then(({
        x, y, placement, middlewareData: {
          arrow: { x: arrowX, y: arrowY },
        },
      }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });

        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right',
        }[placement.split('-')[0]];

        Object.assign(tooltipArrow.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY !== null ? `${arrowY}px` : '',
          right: '',
          bottom: '',
          [staticSide]: '-5px',
        });
      });
    }

    function showTooltip() {
      tooltip.style.display = 'block'; // eslint-disable-line no-param-reassign
      update();
    }

    function hideTooltip() {
      tooltip.style.display = ''; // eslint-disable-line no-param-reassign
    }

    [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ].forEach(([event, listener]) => {
      button.addEventListener(event, listener);
    });
  }
}

domReady(() => {
  ExhibitionViewOptions.init();
});
